// @ts-nocheck

export const handleEditModeLifecycleTelemetry = () => {
  if (Math.random() < 0.2) {
    // @ts-ignore: don't look at me, I was crying when I wrote this
    // eslint-disable-next-line no-console
    console.log('🪦 RIP Inline Edit Mode 2024–2025');
  }
};
